import { css } from '@emotion/react'
import React from 'react'
import { Tag } from '../base-ui'
import ItemList from './ItemList'

function LinkBox({ items, transparent = false }) {
    return (
        <div
            css={css`
                padding: 1rem;
                ${!transparent && 'background-color: #fff;'}
                margin-top: 1rem;
                ${!transparent && 'border: 1px solid #ddd;'}
            `}
        >
            <ItemList direction="horizentel" gap="0.5rem" wrap>
                {items.map((item, idx) => (
                    <Tag key={idx} href={item.href} nofollow={item.nofollow} target="_blank">
                        {item.title}
                    </Tag>
                ))}
            </ItemList>
        </div>
    )
}

export default LinkBox
